import React, { Component } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PaymentOptions from '../PaymentOptions';
import PaymentButton from '../PaymentButton';
import DatePickerOrder from '../DatePickerOrder';
import OptionsForOrder from '../../DefaultMenu/OptionsForOrder';
import currencyUtils from 'utils/currency';
import timeUtils from 'utils/time';
import objectUtils from 'utils/object';
import * as actions from 'actions/index';
import '../Cart.css';
import Aux from 'hoc/ReactAux/ReactAux';
import moment from 'moment';
import ModalConfirm from 'components/UI/Modal/ModalConfirm';
import ModalError from 'components/UI/Modal/ModalError';
import ModalCartMessage from 'components/UI/Modal/ModalCartMessage';
import Spinner from '../../../../components/UI/Spinner/Spinner';

class CartProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cutlery: false,
      timeForOrder: null,
      payOption: '',
      cardSelected: '',
      payType: null,
      payWithAnotherCard: false,
      currencySimbol: '€',
      currency: 'EUR',
      specialNotes: '',
      discounts: {},
      showDeliveryTomorrowConfirmationModal: false,
      deliveryDateOnly: null,
      selectAddress: false,
      openModalClearBasket: false,
      totalTip: 0,
      tipCustom: 0,
      tipValue: 0,
    };
  }

  componentDidUpdate(prevProps) {
    this.handleCampaignRate(prevProps);
    if (
      prevProps.productsOnCart.length !== this.props.productsOnCart.length ||
      this.props.campaignRateCollection !== prevProps.campaignRateCollection
    )
      this.handleCalculateValuesCart();
    if (
      this.props.restaurantSelected &&
      JSON.stringify(this.props.restaurantSelected) !==
        JSON.stringify(prevProps.restaurantSelected)
    ) {
      let currency = this.props.restaurantSelected.currency;
      let currencySimbol = currencyUtils.convertNameToSymbol(currency);

      localStorage.setItem('currency', currency);
      this.setState({
        specialNotes: '',
        timeForOrder: null,
        cardSelected: null,
        payType: null,
        currency: currency,
        currencySimbol: currencySimbol,
        isSpinnerVisible: false,
      });
    }
  }
  handleConfirmOkCartModal = () => {
    this.setState({ openModalClearBasket: false });
    this.setState({ selectAddress: true });
    this.props.onDeleteAllproductsFromCard();
  };

  handleDenyCartModal = () => {
    this.setState({ openModalClearBasket: false });
  };

  handleCampaignRate = prevProps => {
    if (
      this.props.restaurantSelected &&
      JSON.stringify(this.props.restaurantSelected) !==
        JSON.stringify(prevProps.restaurantSelected)
    ) {
      this.props.onFetchingCampaignRate(this.props.restaurantSelected.id);
    }
  };

  handleIncreaseQuantityProduct = product => {
    this.props.onAddProductToCart({
      product: product,
      business: this.props.restaurantSelected,
    });
  };

  handleDecreaseProduct = product => {
    this.props.onDeleteProductFromCart({
      product: product,
    });
  };

  onHandleSelectPaymentMethod = (id, type) => {
    switch (type) {
      case 'ideal':
        this.setState({
          payOption: 'ideal',
          payType: 'I',
          payWithAnotherCard: true,
        });
        break;
      case 'bancontact':
        this.setState({
          payOption: 'bancontact',
          payType: 'B',
          payWithAnotherCard: true,
        });
        break;
      case 'onAccount':
        this.setState({ payOption: 'onAccount', payType: 'A' });
        break;
      case 'onCreditCard':
        if (id === 'payWithAnotherCard') {
          this.setState({
            payOption: 'onCreditCard',
            payType: 'C',
            cardSelected: null,
            payWithAnotherCard: true,
          });
        } else {
          let card = this.props.cards.find(item => {
            return item.cardId === id;
          });
          this.setState({
            payOption: 'onCreditCard',
            payType: 'C',
            cardSelected: card,
            payWithAnotherCard: false,
          });
        }
        break;
      case 'onVoucher':
        this.setState({ payOption: 'onVoucher', payType: 'A' });
        break;
      default:
        break;
    }
  };

  onHandleAddCutlery = event => {
    this.setState({ cutlery: event.target.checked });
  };

  handleSpecialNotes = event => {
    this.setState({ specialNotes: event.target.value });
  };

  onDeliveryTomorrow = ({ target }) => {
    this.props.changeDeliveryTomorrow(target.checked);
    if (target.checked) {
      this.setState({
        deliveryDateOnly: moment()
          .add(1, 'day')
          .format('DD/MM/YYYY'),
      });
    } else {
      this.setState({ deliveryDateOnly: moment().format('DD/MM/YYYY') });
    }
  };

  handleDeliveryTomorrow = () => {
    this.setState({ isSpinnerVisible: true });
    if (this.props.deliveryTomorrow) {
      this.setState({ showDeliveryTomorrowConfirmationModal: true });
    } else {
      this.onHandlePlaceOrder();
    }
  };

  handleDeliveryTomorrowCancel = () => {
    this.setState({ showDeliveryTomorrowConfirmationModal: false });
  };

  handleDeliveryTomorrowConfirm = () => {
    this.setState({ showDeliveryTomorrowConfirmationModal: false });
    this.onHandlePlaceOrder();
  };

  onHandlePlaceOrder = () => {
    if (
      this.props.restaurantSelected &&
      !this.props.restaurantSelected.isOpen
    ) {
      let errorMessage =
        'Sorry ' + this.props.restaurantSelected.name + ' is already Closed. ';
      this.props.triggerModalErrorPlacedOrder(errorMessage);
    } else if (
      this.props.restaurantSelected &&
      (this.props.restaurantSelected.platter ||
        this.props.restaurantSelected.forCollection === 'Y') &&
      !!!this.state.timeForOrder
    ) {
      let errorMessage = this.props.restaurantSelected.platter
        ? 'Please select a delivery time for your order'
        : 'Please select a collection time for your order';
      this.props.triggerModalErrorPlacedOrder(errorMessage);
    } else if (
      this.state.payOption === 'onAccount' &&
      !!this.props.business.valueLimit &&
      this.props.business.valueLimit < this.props.total
    ) {
      let errorMessage =
        'Corporate policy currently limits orders to ' +
        this.state.currencySimbol +
        this.props.business.valueLimit.toFixed(2) +
        ' per order.';
      this.props.triggerModalErrorPlacedOrder(errorMessage);
    } else if (this.props.restaurantSelected) {
      let order = this.buildingOrder();
      if (this.state.payType === 'C' && !this.state.payWithAnotherCard) {
        this.handlePlaceOrderAndPay(order);
      } else if (
        (this.state.payType === 'C' && !!this.state.payWithAnotherCard) ||
        this.state.payType === 'I' ||
        this.state.payType === 'B'
      ) {
        this.props.handlePlaceOrderAndGoToAddNewCard(
          order,
          this.getPayInfo(),
          this.props.history
        );
      } else {
        this.props.onPlaceOrder(order, this.getPayInfo());
      }
    }
  };

  getAddressForOrder = () => {
    if (this.props.restaurantSelected.forCollection === 'Y') {
      return this.props.addresses.find(item => item.forCollection)
        .idBusinessAddress;
    } else {
      return this.props.addresses.find(item => !item.forCollection)
        .idBusinessAddress;
    }
  };

  getCustomerAddressForOrder = () => {
    return this.props.addresses.find(item => !item.forCollection)
      .idCustomerDeliveryAddress;
  };

  getOrderItems = () => {
    return this.props.productsOnCart.map(product => {
      if (product.mealOptions) {
        let mealOptions = product.mealOptions.map(mealOption => {
          return {
            idProduct: mealOption.idProduct || mealOption.idMealOption,
            idCategoryType: mealOption.idCategoryType,
          };
        });
        return {
          quantity: 1,
          specialNotes: product.specialInstructions,
          product: { id: product.id },
          total: product.price,
          mealOptions: mealOptions,
        };
      } else {
        return {
          quantity: 1,
          product: { id: product.id },
          total: product.price,
        };
      }
    });
  };

  buildingOrder = () => {
    let orderItems = this.getOrderItems();

    let specialNotes = this.state.cutlery
      ? this.state.specialNotes + '. Please add cutlery'
      : this.state.specialNotes;

    let order = {
      totalAmount: this.props.total,
      specialNotes: specialNotes,
      tipValue: this.getTotalTip(),
      restaurant: { id: this.props.restaurantSelected.id },
      orderItems: orderItems,
      businessDeliveryAddress: { id: this.getAddressForOrder() },
      customerDeliveryAddress: { id: this.getCustomerAddressForOrder() },
      payType: this.state.payType,

      deliveryDateOnly: this.props.deliveryTomorrow
        ? this.state.deliveryDateOnly
        : null,
    };

    const isDeliverAtHome =
      this.getDeliverAddress() != null
        ? this.getDeliverAddress().idCustomerDeliveryAddress != null
        : false;

    if (
      this.props.restaurantSelected.forCollection === 'Y' ||
      this.props.restaurantSelected.platter ||
      isDeliverAtHome
    ) {
      let deliveryDate;
      if (this.state.timeForOrder == null) {
        // 01:00 PM
        deliveryDate =
          timeUtils.getCurrentDate() +
          ' ' +
          timeUtils.millisecondsToTime(46800);
      } else if (this.state.timeForOrder._isAMomentObject) {
        deliveryDate = this.state.timeForOrder.format('DD/MM/YYYY HH:mm');
      } else {
        deliveryDate =
          timeUtils.getCurrentDate() +
          ' ' +
          timeUtils.millisecondsToTime(this.state.timeForOrder);
      }
      order = {
        ...order,
        deliveryDate: deliveryDate,
        deliverAtHome: isDeliverAtHome,
      };
    }

    return order;
  };

  isPayTypeEqualToCreditCard = () => {
    return this.state.payType === 'C';
  };

  getAmountPayInfo = () => {
    let amount = this.props.total;
    amount +=
      this.state.payType === 'C' && !!this.props.campaignRateCC
        ? this.props.campaignRateCC.amount
        : 0;
    return amount;
  };

  getPayInfo = () => {
    return {
      amount: this.getAmountPayInfo(),
      currency: this.state.currency,
      payType: this.state.payType,
      paymentReference: objectUtils.get(
        this.state,
        'cardSelected.cardId',
        undefined
      ),
      tipValue: this.getTotalTip(),
      idBusinessRestaurant: objectUtils.get(
        this.props,
        'restaurantSelected.id',
        undefined
      ),
      payObjectType: 'O',
      discounts: this.props.discounts,
    };
  };

  handlePlaceOrderAndPay = order => {
    this.props.onPlaceOrderAndPay(order, this.getPayInfo());
  };

  handleTimeForOrder = date => {
    this.setState({ timeForOrder: date });
  };

  getTaxDelivery = () => {
    return !!this.props.restaurantSelected &&
      this.props.restaurantSelected.taxDelivery &&
      this.isDeliverAtHome()
      ? this.props.restaurantSelected.taxDelivery.toFixed(2)
      : Number(0).toFixed(2);
  };

  getStyleInputTipCustom = () => {
    var number = this.state.totalTip;
    return number > 20
      ? 'tip-custom-amount-input-container'
      : 'tip-custom-amount-input-container-hidden';
  };

  getStyleButtonTipCustom = () => {
    var number = this.state.totalTip;
    return number > 20 ? 'tip-custom-selected' : 'tip-custom';
  };

  getStyleButtonTip = button => {
    var number = this.state.totalTip;
    return number === button ? 'tip-percent-selected' : 'tip-percent';
  };

  formatNumber(n) {
    return n.replace(/\D/g, '').replace(/(\d)(\d{2})$/, '$1.$2');
  }

  onClickTip = event => {
    switch (event.target.value) {
      case '0':
        if (this.state.totalTip === 0) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 0,
          });
        }

        break;
      case '5':
        if (this.state.totalTip === 5) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 5,
          });
        }

        break;

      case '10':
        if (this.state.totalTip === 10) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 10,
          });
        }

        break;

      case '20':
        if (this.state.totalTip === 20) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 20,
          });
        }

        break;

      default:
        if (this.state.totalTip === 21) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 21,
          });
        }

        break;
    }
  };

  onChangeInputTip = event => {
    this.setState({
      tipCustom: this.formatNumber(event.target.value),
    });
  };

  verfifyNumber = number => {
    var numberFormated = number;

    if (number.length > 5) {
      numberFormated = number.replace('.', '');
      numberFormated = this.formatNumber(numberFormated);
    } else {
      return Number(number);
    }

    return numberFormated;
  };

  getTotalTip = () => {
    var tipValue =
      this.state.totalTip < 21
        ? Number.parseFloat(
            ((this.props.subtotal * this.state.totalTip) / 100).toPrecision(2)
          )
        : this.state.tipCustom === 0
        ? Number(this.state.tipCustom)
        : Number(this.verfifyNumber(this.state.tipCustom));

    return tipValue;
  };

  getTotal = () => {
    return this.getTotalTip() + this.props.total;
  };

  getMaxBasketCost = () => {
    if (!!this.props.maxBasketCost) {
      return `(for ${
        this.state.currencySimbol
      } ${this.props.maxBasketCost.toFixed(2)} max)`;
    }
    return '';
  };

  getDeliverAddress = () => {
    return this.props.addresses[0];
  };

  showOptionsForOrder = () => {
    this.setState({ openModalClearBasket: true });
  };

  showCollectionOption = () => {
    return (
      !this.props.addresses.find(address => address.forCollection) &&
      this.props.showCollectionOption
    );
  };

  toggleCart = () => {
    this.props.onToggleCart();
  };

  handleSelectOptionForOrder = address => {
    this.props.onSelectAddressForOrder([address]);
    this.setState({ selectAddress: false });
    this.props.restaurantSelected &&
      this.props.onCalculateSubsidy(
        this.props.restaurantSelected.id,
        0,
        this.props.restaurantSelected.taxDelivery && this.isDeliverAtHome()
          ? this.props.restaurantSelected.taxDelivery
          : 0,
        this.getTotalTip()
      );
  };

  closeModalErrorAndClearLocalStorageRestaurantCurrentIsOpen = () => {
    this.props.onCartSetRestaurantOpen(true);
    this.props.onDeleteAllproductsFromCard();
    window.location.reload();
  };

  handleCreateCustomerDeliveryAddress = async place => {
    await this.props.onCreateCustomerDeliveryAddress(place);
    this.setState({ selectAddress: false });
    this.props.onCalculateSubsidy(
      this.props.restaurantSelected.id,
      0,
      this.props.restaurantSelected.taxDelivery && this.isDeliverAtHome()
        ? this.props.restaurantSelected.taxDelivery
        : 0,
      this.getTotalTip()
    );
  };

  isDeliverAtHome = () => {
    return this.getDeliverAddress() != null
      ? this.getDeliverAddress().idCustomerDeliveryAddress != null
      : false;
  };

  handleCalculateValuesCart = () => {
    let tipValue = this.getTotalTip();
    let subtotal = this.props.productsOnCart.reduce((a, product) => {
      return a + product.price;
    }, 0);

    if (
      (!!this.props.campaignRateCollection &&
        this.props.subtotal !== subtotal) ||
      (!!this.props.campaignRateCollection &&
        this.props.tipValue !== this.getTotalTip())
    ) {
      if (
        this.props.restaurantSelected.forCollection === 'N' &&
        this.props.restaurantCurrentIsOpen
      ) {
        this.props.onCalculateSubsidy(
          this.props.restaurantSelected.id,
          subtotal,
          this.props.restaurantSelected.taxDelivery && this.isDeliverAtHome()
            ? this.props.restaurantSelected.taxDelivery
            : 0,
          tipValue
        );
      } else {
        this.props.onAppliedCartValues(
          subtotal,
          0,
          subtotal,
          0,
          this.props.discounts,
          tipValue
        );
      }
    }
  };

  isWithVoucherOrNotAcceptTip = () => {
    const isVoucher =
      this.props.total === 0 &&
      this.props.subsidy > 0 &&
      !this.props.onlyCreditCard;
    const acceptTip =
      this.props.restaurantSelected !== null &&
      !this.props.restaurantSelected.acceptTip;

    return isVoucher || acceptTip;
  };

  render() {
    return (
      <Aux tabIndex={0}>
        <button
          title="Close (Esc)"
          type="button"
          className="btn-close"
          onClick={() => this.toggleCart()}
          aria-label="Close cart"
        />
        <h2>Your Cart includes </h2>
        <ul className="items">
          {this.props.productsOnCart.map((product, index) => (
            <li key={index} className="item">
              <button
                onClick={() => this.handleDecreaseProduct(product)}
                className="remove-item"
                aria-label={`Remove ${product.name}`}
                aria-describedby={`product-desc-${index}`}
              />
              <div className="flex-center" tabIndex={0}>
                <button
                  onClick={() => this.handleIncreaseQuantityProduct(product)}
                  className="btn-add-product"
                  aria-label="Increase quantity"
                />
                <h3 tabIndex={0}>
                  {product.name}{' '}
                  {this.state.currencySimbol + product.price.toFixed(2)}
                </h3>
              </div>
              <p
                tabIndex={0}
                className="product-cart-description"
                id={`product-desc-${index}`}
              >
                {product.description}
              </p>
            </li>
          ))}
        </ul>

        <div className="items" hidden={this.isWithVoucherOrNotAcceptTip()}>
          <p className="tip-title" tabIndex={0}>
            Tip the Driver (optional)
          </p>
          <div className="tip">
            <button
              value="5"
              className={this.getStyleButtonTip(5)}
              onClick={this.onClickTip}
            >
              5 %
            </button>
            <button
              value="10"
              className={this.getStyleButtonTip(10)}
              onClick={this.onClickTip}
            >
              10 %
            </button>
            <button
              value="20"
              className={this.getStyleButtonTip(20)}
              onClick={this.onClickTip}
            >
              20 %
            </button>
          </div>
          <div>
            <button
              value="6"
              className={this.getStyleButtonTipCustom()}
              onClick={this.onClickTip}
            >
              <b>Enter Custom Amount</b>
            </button>
            <div className={this.getStyleInputTipCustom()}>
              <input
                className="tip-custom-amount-input"
                placeholder=" 0.00 "
                value={
                  this.state.tipCustom === 0 ? undefined : this.state.tipCustom
                }
                onChange={this.onChangeInputTip}
                data-type="currency"
              />
              <span className="sufix-tip-custom">
                {this.state.currencySimbol + ' '}
              </span>
              <svg
                className="icon-tip-custom"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="9" cy="9" r="9" fill="#FF5007" />
                <path
                  d="M6 10.2594L8.25 11.8359L12 7.50035"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className="total-items">
          <div className="sub-total">
            <div className="left">
              <p tabIndex={0}>Sub Total</p>
            </div>
            <div className="right">
              <p tabIndex={0}>
                {this.state.currencySimbol + this.props.subtotal.toFixed(2)}
              </p>
            </div>
          </div>
          <div
            className="sub-total"
            hidden={this.isWithVoucherOrNotAcceptTip()}
          >
            <div className="left">
              <p tabIndex={0}>Tip</p>
            </div>
            <div className="right">
              <p tabIndex={0}>
                {this.state.currencySimbol + this.getTotalTip().toFixed(2)}
              </p>
            </div>
          </div>
          {this.props.restaurantSelected &&
            this.props.restaurantSelected.forCollection === 'N' && (
              <div className="subsidy">
                <div className="left">
                  <p tabIndex={0}>Subsidy {this.getMaxBasketCost()}</p>
                </div>
                <div className="right">
                  <p tabIndex={0}>
                    {this.state.currencySimbol + this.props.subsidy}
                  </p>
                </div>
              </div>
            )}
          {this.props.restaurantSelected &&
            this.props.restaurantSelected.forCollection === 'N' && (
              <div className="subsidy">
                <div className="left">
                  <p tabIndex={0}>Delivery Fee</p>
                </div>
                <div className="right">
                  <p tabIndex={0}>
                    {this.state.currencySimbol + this.getTaxDelivery()}{' '}
                  </p>
                </div>
              </div>
            )}
          {!!this.props.campaignRateCollection &&
            this.props.restaurantSelected &&
            this.props.restaurantSelected.forCollection === 'Y' && (
              <div className="collection-discount">
                <div className="left">
                  <p tabIndex={0}>Collection discount</p>
                </div>
                <div className="right">
                  <p tabIndex={0}>
                    {this.props.campaignRateCollection.discountType === 'P'
                      ? '% '
                      : '- '}
                    {this.props.campaignRateCollection.amount}
                  </p>
                </div>
                this.props.onDeleteAllproductsFromCard();
              </div>
            )}
          <div className="total">
            <div className="left">
              <p tabIndex={0}>Total</p>
            </div>
            <div className="right" tabIndex={0}>
              {this.state.currencySimbol + this.getTotal().toFixed(2)}
            </div>
          </div>
        </div>
        <div className="items">
          <div className="checked-cutlery">
            <input
              onChange={evt => this.onHandleAddCutlery(evt)}
              type="checkbox"
              id="cutlery1"
              name="cutlery"
            />
            <label htmlFor="cutlery1">
              <b>Add Cutlery (Free)</b>
            </label>
          </div>
        </div>
        <div className="special-notes" tabIndex={0}>
          <div className="left">
            <p tabIndex={0}>Special notes</p>
          </div>
          <textarea
            value={this.state.specialNotes}
            onChange={this.handleSpecialNotes}
          />
          <p tabIndex={0}>
            Deliver @{' '}
            {this.getDeliverAddress() != null
              ? this.getDeliverAddress().street
              : null}
          </p>
          <p tabIndex={0}>
            or{' '}
            <a onClick={e => this.showOptionsForOrder()}>
              <u>change here</u>
            </a>
          </p>
        </div>

        <DatePickerOrder
          restaurantSelected={this.props.restaurantSelected}
          handleTimeForOrder={this.handleTimeForOrder}
          timeForOrder={this.state.timeForOrder}
          deliveryTomorrow={this.props.deliveryTomorrow}
          onDeliveryTomorrow={this.onDeliveryTomorrow}
          ordersAhead={this.props.business && this.props.business.ordersAhead}
          isDeliverAtHome={this.isDeliverAtHome()}
        />

        <OptionsForOrder
          onFetchingMenu={this.props.onFetchingMenu}
          idBusiness={this.props.userDetails.idBusiness}
          listAddress={this.props.listAddress}
          showModal={this.state.selectAddress}
          showCollectionOption={this.showCollectionOption()}
          showDeliverAtHomeOption={this.props.showDeliverAtHomeOption}
          selectOptionForOrder={this.handleSelectOptionForOrder}
          onToggleCart={this.props.onToggleCart}
          onDeleteAllproductsFromCard={this.props.onDeleteAllproductsFromCard}
          createCustomerDeliveryAddress={
            this.handleCreateCustomerDeliveryAddress
          }
          onCartResetState={this.props.onCartResetState}
          onDeleteRestaurantSelected={this.props.onDeleteRestaurantSelected}
          onFetchingRecentlyOrdered={this.props.onFetchingRecentlyOrdered}
        />

        <ModalError
          style={{ zIndex: '99999', position: 'absolute', margin: '5% 26%' }}
          showModal={!this.props.restaurantCurrentIsOpen}
          errorMessage={'Restaurant not available, please refresh the website'}
          actionButtonTitle="Ok"
          actionButton={
            this.closeModalErrorAndClearLocalStorageRestaurantCurrentIsOpen
          }
        />

        <ModalCartMessage
          clickButtonConfirm={this.handleConfirmOkCartModal}
          clickButtonDeny={this.handleDenyCartModal}
          message={
            <strong>
              Note!
              <br />
              <br />
              Clear current basket to change address?
            </strong>
          }
          showModal={this.state.openModalClearBasket}
        />
        <PaymentOptions
          payTypeSelected={this.state.payType}
          cardSelected={this.state.cardSelected}
          selectPaymentMethod={this.onHandleSelectPaymentMethod}
          total={this.props.total}
          subsidy={this.props.subsidy}
          business={this.props.business}
          cards={this.props.cards}
        />

        {this.props.isLoading ? (
          <Spinner nameClass={'lds-third'} />
        ) : (
          <PaymentButton
            payTypeSelected={this.state.payType}
            campaignRateCC={this.props.campaignRateCC}
            disabled={this.props.productsOnCart > 0}
            handlePlaceOrder={this.handleDeliveryTomorrow}
            total={this.props.total}
          />
        )}

        {this.state.showDeliveryTomorrowConfirmationModal ? (
          <ModalConfirm
            title={'Confirm delivery for tomorrow'}
            onClose={this.handleDeliveryTomorrowCancel}
            onConfirm={this.handleDeliveryTomorrowConfirm}
          >
            <div>
              <h2 style={{ textTransform: 'none', fontSize: '20px' }}>
                Are you sure that you want your order delivery for tomorrow?
              </h2>
            </div>
          </ModalConfirm>
        ) : null}
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    subtotal: state.cartReducer.cart.subtotal,
    subsidy: state.cartReducer.cart.subsidy,
    tipValue: state.cartReducer.cart.tipValue,
    total: state.cartReducer.cart.total,
    isLoading: state.loadingReducer.loading,
    maxBasketCost: state.cartReducer.cart.maxBasketCost,
    productsOnCart: state.cartReducer.cart.products,
    productSelected: state.cartReducer.cart.productSelected,
    cards: state.cartReducer.cart.cards,
    restaurantCurrentIsOpen: state.cartReducer.cart.restaurantCurrentIsOpen,
    restaurantSelected: state.cartReducer.cart.restaurantSelected,
    business: state.businessReducer.business,
    addresses: state.menuReducer.addresses,
    listAddress: state.menuReducer.listAddress,
    showDeliverAtHomeOption: state.menuReducer.acceptDeliverAtHome,
    campaignRateCC: state.cartReducer.cart.campaignRateCC,
    campaignRateCollection: state.cartReducer.cart.campaignRateCollection,
    discounts: state.cartReducer.cart.discounts,
    deliveryTomorrow: state.cartReducer.cart.deliveryTomorrow,
    userDetails: state.authenticationReducer.userDetails,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    triggerModalErrorPlacedOrder: erroMessage =>
      dispatch(actions.triggerModalErrorPlacedOrder(erroMessage)),
    onDeleteProductFromCart: product =>
      dispatch(actions.deleteProductFromCart(product)),
    onAddProductToCart: product => dispatch(actions.addProductToCart(product)),
    onCalculateSubsidy: (idRestaurant, subTotal, taxDelivery, tipValue) =>
      dispatch(
        actions.calculateSubsidy(idRestaurant, subTotal, taxDelivery, tipValue)
      ),
    onAppliedCartValues: (
      subTotal,
      subsidy,
      total,
      maxBasketCost,
      discounts,
      tipValue
    ) =>
      dispatch(
        actions.appliedCartValues(
          subTotal,
          subsidy,
          total,
          maxBasketCost,
          discounts,
          tipValue
        )
      ),
    onFetchingMenu: (idBusiness, idAddress) =>
      dispatch(actions.fetchingMenu(idBusiness, idAddress)),
    onSelectForColectionOption: () =>
      dispatch(actions.changeRestaurantOptions(2)),
    onFetchingCampaignRate: idBusiness =>
      dispatch(actions.fetchingCampaignRate(idBusiness)),
    onPlaceOrder: (order, payInfo) =>
      dispatch(actions.placeOrder(order, payInfo)),
    onPlaceOrderAndPay: (order, payInfo) =>
      dispatch(actions.placeOrderAndPay(order, payInfo)),
    handlePlaceOrderAndGoToAddNewCard: (order, payInfo, history) =>
      dispatch(actions.placeOrderAndGoToAddNewCard(order, payInfo, history)),
    onToggleCart: () => dispatch(actions.toggleCart()),
    changeDeliveryTomorrow: payload =>
      dispatch(actions.changeDeliveryTomorrow(payload)),
    onSelectAddressForOrder: address =>
      dispatch(actions.selectAddressForOrder(address)),
    onCreateCustomerDeliveryAddress: place =>
      dispatch(actions.createCustomerDeliveryAddress(place)),
    onDeleteAllproductsFromCard: () =>
      dispatch(actions.deleteAllProductsFromCart()),
    onCartResetState: () => dispatch(actions.cartResetState()),
    onDeleteRestaurantSelected: () =>
      dispatch(actions.deleteRestaurantSelected()),
    onFetchingRecentlyOrdered: idAddress =>
      dispatch(actions.fetchingRecentlyOrdered(idAddress)),
    onCartSetRestaurantOpen: restaurantCurrentIsOpen =>
      dispatch(actions.cartSetRestaurantOpen(restaurantCurrentIsOpen)),
    closeModalError: history => dispatch(actions.closeModalError(history)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CartProduct)
);



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/CartProduct/index.js